import script from "./details.vue?vue&type=script&lang=ts&setup=true"
export * from "./details.vue?vue&type=script&lang=ts&setup=true"

import "./details.vue?vue&type=style&index=0&id=70a894cb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a894cb"]])

export default __exports__